// extracted by mini-css-extract-plugin
module.exports = {"box":"dropdown_box__8CpKU"};